import { PreloadConfig } from './config-types';
import { workerManager } from './worker-manager';

/**
 * Preload the resources using the provided configuration. This function is used to preload the model
 * and the worker before creating the pipeline.
 *
 * @param config - The configuration object.
 */
export const preload = async (config: PreloadConfig) => {
    await workerManager.preloadWorker(config);
};
